// Shared helpers for the Vertical Builder (mirror backend vertical_builder.normalize).
export const TAB_NAMES = {
  connect: "Professionals & Leads", jobs: "Jobs", barber: "Appointments", booking: "Bookings", board: "Order board",
  completed: "Completed", register: "Register", products: "Products", locations: "Locations", customers: "Customers",
  loyalty: "Loyalty", reporting: "Reporting", marketing: "Marketing", events: "Events", settings: "Settings", help: "Help",
};
export const STATUS = { draft: "Draft", coming_soon: "Coming soon", live: "Live" };
export const LEX_LABELS = {
  item: "One item", items: "Items", order: "One order", orders: "Orders", customer: "One customer", customers: "Customers",
  provider: "One provider", providers: "Providers", book_verb: "Customer action", catalog: "Catalog name",
};

export function lockedModules(flow, flows) {
  return [flows[flow]?.module, "settings", "help"].filter(Boolean);
}

export function deriveTabs(r, modules, flows) {
  const byKey = Object.fromEntries(modules.map((m) => [m.key, m]));
  const mods = [...new Set([flows[r.flow]?.module, ...(r.modules || []).filter((m) => byKey[m]?.built), "settings", "help"].filter(Boolean))];
  const allowed = mods.flatMap((m) => byKey[m].tabs);
  const head = (r.tabs || []).filter((t) => allowed.includes(t));
  const rest = allowed.filter((t) => !head.includes(t) && t !== "settings" && t !== "help");
  const tail = ["settings", "help"].filter((t) => !head.includes(t));
  return [...new Set([...head, ...rest, ...tail])];
}

export const tabName = (r, t) => r.labels?.[t] || TAB_NAMES[t] || t;

export const BLANK = {
  label: "", blurb: "", icon: "store", product: "morrcart", price_note: "", flow: "order", status: "draft",
  modules: ["customers", "reporting", "marketing"], tabs: [], default_tab: "", labels: {}, lexicon: {},
  storefront: { cta: "", catalog_heading: "" }, categories: [], description: "",
};
